<div class="fx-column">
<div class="title-format">EOLA - Critical and Major Current Week Findings</div>
<div class="no-issues-format" *ngIf="noIssues && !isLoading"><br><br>No issues to display.</div>


    <div class="fx-row" *ngFor="let issue of topThree">
        <div class="fx-image-column image-container">
            <img *ngIf="issue.imageSrc" [src]="issue.imageSrc" alt="Issue image"/>
            <div *ngIf="!issue.imageSrc" class="no-image-placeholder">
                <span>No Picture Available</span>
            </div>
        </div>
        <div class="fx-detail-column">
            <div class="fx-detail-row">
                <span class="text-format">Line:</span>
                <span class="text-format">{{issue.Line}}</span>
            </div>
            <div class="fx-detail-row2">
                <span class="text-format">EOLA Alarm Severity:</span>
                <span class="text-format">{{issue.Severity}}</span>
            </div>
            <div class="fx-detail-row">
                <span class="text-format">Model: </span>
                <span class="text-format">{{issue.Model}}</span>
            </div>
            <div class="fx-detail-row2">
                <span class="text-format">Serial:</span>
                <span class="text-format">{{issue.Serial}}</span>
            </div>
            <div class="fx-detail-row">
                <span class="text-format">Area Description: </span>
                <span class="text-format">{{issue.AreaDescription}}</span>
            </div>
            <div class="fx-detail-row2">
                <span class="text-format">Component: </span>
                <span class="text-format">{{issue.ComponentDescription}}</span> 
            </div>
            <div class="fx-detail-row">
                <span class="text-format">Defect: </span        >
                <span class="text-format">{{issue.DefectDescription}}</span>
            </div>
        </div>
    </div>   